module.exports = __webpack_public_path__ + "static/media/11.9cf7f174.png";